import React from 'react';
import MythicCommanderBanner from 'components/Elements/Shared/MythicCommanderBanner';
import styles from './Header.module.css';

export default () => {
  return (
    <div className={styles.header}>
      <MythicCommanderBanner fontSize={18} />
    </div>
  );
};
